export default [
  {
    key: 'userSessionExpiresIn',
    label: 'label.userSessionExpiresIn',
    hint: 'label.userSessionInstruction',
    type: 'number',
    rules: 'required',
    cols: 12
  },
  {
    key: 'allowedMetaFields',
    label: 'label.allowedMetaFields',
    hint: 'label.allowedMetaFieldsInstruction',
    type: 'text',
    cols: 12
  },
  {
    key: 'unreadTimeToNotifySwitch',
    label: 'label.unreadTimeToNotifySwitch',
    hint: 'label.unreadTimeToNotifySwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'unreadTimeToNotify',
        label: 'label.unreadTimeToNotify',
        hint: 'label.unreadTimeToNotifyInstruction',
        type: 'number',
        rules: 'required',
        cols: 12
      },
      {
        key: 'notifyUrl',
        label: 'label.notifyUrl',
        hint: 'label.notifyUrlInInstruction',
        type: 'text',
        rules: 'url_custom_extension',
        cols: 12
      },
      {
        key: 'authorization',
        label: 'label.authorization',
        hint: 'label.authorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  },
  {
    key: 'closeChannelToNotifySwitch',
    label: 'label.closeChannelToNotifySwitch',
    hint: 'label.closeChannelToNotifySwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'closeChannelToNotifyUrl',
        label: 'label.closeChannelToNotifyUrl',
        hint: 'label.closeChannelToNotifyUrlInstruction',
        type: 'text',
        rules: 'url_custom_extension',
        cols: 12
      },
      {
        key: 'closeChannelToNotifyAuthorization',
        label: 'label.closeChannelToNotifyAuthorization',
        hint: 'label.closeChannelToNotifyAuthorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  },
  {
    key: 'newChatMessageToNotifySwitch',
    label: 'label.newChatMessageToNotifySwitch',
    hint: 'label.newChatMessageToNotifySwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'newChatMessageToNotifyUrl',
        label: 'label.newChatMessageToNotifyUrl',
        hint: 'label.newChatMessageToNotifyUrlInstruction',
        type: 'text',
        rules: 'url_custom_extension',
        cols: 12
      },
      {
        key: 'newChatMessageToNotifyAuthorization',
        label: 'label.newChatMessageToNotifyAuthorization',
        hint: 'label.newChatMessageToNotifyAuthorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  },
  {
    key: 'remoteProjectSwitch',
    label: 'label.remoteProjectSwitch',
    hint: 'label.remoteProjectSwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'remoteProjectUrl',
        label: 'label.remoteProjectUrl',
        hint: 'label.remoteProjectUrlInstruction',
        type: 'text',
        rules: 'url_custom_extension|required',
        cols: 12
      },
      {
        key: 'remoteProjectAuthorization',
        label: 'label.remoteProjectAuthorization',
        hint: 'label.remoteProjectAuthorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  },
  {
    key: 'remoteServiceCategorySwitch',
    label: 'label.remoteServiceCategorySwitch',
    hint: 'label.remoteServiceCategorySwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'remoteServiceCategoryUrl',
        label: 'label.remoteServiceCategoryUrl',
        hint: 'label.remoteServiceCategoryUrlInstruction',
        type: 'text',
        rules: 'url_custom_extension|required',
        cols: 12
      },
      {
        key: 'remoteServiceCategoryAuthorization',
        label: 'label.remoteServiceCategoryAuthorization',
        hint: 'label.remoteServiceCategoryAuthorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  },
  {
    key: 'remoteServiceTypeSwitch',
    label: 'label.remoteServiceTypeSwitch',
    hint: 'label.remoteServiceTypeSwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'remoteServiceTypeUrl',
        label: 'label.remoteServiceTypeUrl',
        hint: 'label.remoteServiceTypeUrlInstruction',
        type: 'text',
        rules: 'url_custom_extension|required',
        cols: 12
      },
      {
        key: 'remoteServiceTypeAuthorization',
        label: 'label.remoteServiceTypeAuthorization',
        hint: 'label.remoteServiceTypeAuthorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  },
  {
    key: 'remoteServiceSubTypeSwitch',
    label: 'label.remoteServiceSubTypeSwitch',
    hint: 'label.remoteServiceSubTypeSwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'remoteServiceSubTypeUrl',
        label: 'label.remoteServiceSubTypeUrl',
        hint: 'label.remoteServiceSubTypeUrlInstruction',
        type: 'text',
        rules: 'url_custom_extension|required',
        cols: 12
      },
      {
        key: 'remoteServiceSubTypeAuthorization',
        label: 'label.remoteServiceSubTypeAuthorization',
        hint: 'label.remoteServiceSubTypeAuthorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  },
  {
    key: 'remoteServiceProductSwitch',
    label: 'label.remoteServiceProductSwitch',
    hint: 'label.remoteServiceProductSwitchInstruction',
    type: 'checkbox',
    switch: true,
    cols: 12,
    children: [
      {
        key: 'remoteServiceProductUrl',
        label: 'label.remoteServiceProductUrl',
        hint: 'label.remoteServiceProductUrlInstruction',
        type: 'text',
        rules: 'url_custom_extension|required',
        cols: 12
      },
      {
        key: 'remoteServiceProductAuthorization',
        label: 'label.remoteServiceProductAuthorization',
        hint: 'label.remoteServiceProductAuthorizationInstruction',
        type: 'text',
        cols: 12
      }
    ]
  }
];
